export default __webpack_public_path__ + "static/sprints-first-image-a474bed0e4a62105b1d38fc448c0ff36.png";